import React, { Component, Fragment } from 'react'
import { Col, Collapse, Grid, Row } from 'react-bootstrap'
import injectSheet from 'react-jss'
import TopBar from 'src/components/top_bar/TopBar'
import Titre1 from 'src/components/font/Titre1'
import P from 'src/components/font/P'
import Produit from 'src/components/Produit'
import Footer from 'src/components/footer/Footer'
import TopBarSearch from 'src/components/top_bar/TopBarSearch'
import Prix from 'src/components/Prix'
import { Link } from 'react-router-dom'
import routes from 'src/routing/routes'
import Oeil from 'src/components/svg/Oeil'
import { withRouter } from 'react-router'
import styles from './FicheProduit.styles'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Helmet } from 'react-helmet'
import responsiveComponent from 'src/hoc/responsiveComponent'
import Breadcrumb from 'src/components/breadcrumb/Breadcrumb'
import Carousel from 'src/components/Carousel'
import {
  categoriesOptions,
  responsiveAd,
  smBannerAd,
  sortPhotosByPosition
} from '../../../config/dataConf'
import { getUrlValueFromValue, interpretHtml } from '../../../utils'
import loadable from '@loadable/component'
import PubContainer from '../../../components/PubContainer'
import Spinner from '../../../components/Spinner'

const ModalContactProducteur = loadable(() =>
  import('src/components/modal/ModalContactProducteur')
)

const queryForNearCity = gql`
  query CityNear($id: ID!) {
    findNearestCityOfAProducer(idProducer: $id) {
      id
      name
    }
  }
`
class FicheProduit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMoreOffer: false
    }
  }

  clickMoreOffer = () => {
    this.setState(prevState => ({
      isMoreOffer: !prevState.isMoreOffer
    }))
  }

  render() {
    const { classes, product, isMobile, loading } = this.props
    const listProducts = product ? product.producerProfile.products : null

    if (listProducts) {
      listProducts.forEach(product => {
        product.photosProduct = product.photosProduct.sort(sortPhotosByPosition)
      })
    }

    return (
      <Fragment>
        {product &&
          product.producerProfile.valid === 'ACCEPTE' &&
          product.available && (
            <Helmet>
              <title>
                {product.name} - {product.producerProfile.companyName} - Vente
                directe producteur - {product.producerProfile.address.city} (
                {product.producerProfile.address.postalCode})
              </title>
              <meta
                name='description'
                content={`${product.name} en vente directe du producteur ${product.producerProfile.companyName} à ${product.producerProfile.address.city} (${product.producerProfile.address.postalCode}). Découvrez ce produit sur Acheter à la Source, ainsi que de nombreux autres produits de qualité en vente directe proches de chez vous.`}
              />
            </Helmet>
          )}
        {/* /////////////// Mobile //////////// */}
        {isMobile ? (
          <div className={classes.wrapper}>
            <TopBar className={classes.topBar} />

            <PubContainer scriptPubCore={responsiveAd} />

            {loading ? (
              <Spinner />
            ) : product &&
              product.producerProfile.valid === 'ACCEPTE' &&
              product.available ? (
              <Grid
                fluid
                className={classes.grid}
                itemScope
                itemType='http://schema.org/Product'
              >
                {product.photosProduct.length > 0 &&
                  product.photosProduct.map((photo, i) => (
                    <link key={i} itemProp='image' href={photo.cloudPath} />
                  ))}
                <div className={classes.imageContainer}>
                  {product.photosProduct.length > 0 ? (
                    <Carousel photos={product.photosProduct} />
                  ) : (
                    <Carousel />
                  )}
                </div>

                <Breadcrumb
                  className={classes.breadcrumbMobile}
                  items={[
                    { name: 'Accueil', to: routes.accueil },
                    {
                      name: product.producerProfile.regionName,
                      to: routes.mapRegion
                        .replace(':category', categoriesOptions[0].value)
                        .replace(
                          ':inseeRegion',
                          product.producerProfile.regionCode
                        )
                        .replace(':page', '1')
                    },
                    {
                      name: product.producerProfile.departmentName,
                      to: routes.mapDepartment
                        .replace(':category', categoriesOptions[0].value)
                        .replace(
                          ':inseeDepartment',
                          product.producerProfile.departmentCode
                        )
                        .replace(':page', '1')
                    },
                    {
                      name: product.producerProfile.companyName,
                      to: routes.ficheProducteur.replace(
                        ':id(\\d+)',
                        product.producerProfile.id
                      )
                    },
                    {
                      name: product.name,
                      active: true
                    }
                  ]}
                />

                <Row>
                  <Col xs={8}>
                    <Titre1 className={classes.name} itemProp='name'>
                      {product.name}
                    </Titre1>
                  </Col>
                </Row>

                <P>
                  Description: <br />
                  <span itemProp='description'>
                    {interpretHtml(product.description.replace(/\n/g, '<br/>'))}
                  </span>
                </P>

                <p className={classes.lienProducteur}>
                  <Link
                    to={routes.ficheProducteur.replace(
                      ':id(\\d+)',
                      product.producerProfile.id
                    )}
                  >
                    <Oeil jaune taille={20} className={classes.oeil} />{' '}
                    Producteur: {product.producerProfile.companyName}
                  </Link>
                </p>

                <div className={classes.categoryColor}>
                  <P className={classes.categorie}>
                    Les catégories de produit de ce producteur :
                  </P>
                  {product.producerProfile.categories &&
                    product.producerProfile.categories.map((categorie, i) => (
                      <Fragment key={i}>
                        <Link
                          to={routes.siteMap.replace(
                            ':category',
                            getUrlValueFromValue(categorie.reference)
                          )}
                          className={classes.categoryColor}
                        >
                          {categorie.reference}
                        </Link>
                        {i !== product.producerProfile.categories.length - 1
                          ? ' - '
                          : ''}
                      </Fragment>
                    ))}
                </div>

                {product.saleMode &&
                  (product.saleMode.offers ? (
                    // PackedSale
                    <div>
                      <Prix
                        price={product.saleMode.offers[0].price}
                        unit={product.saleMode.offers[0].unit}
                        quantity={product.saleMode.offers[0].quantity}
                        pieces={product.saleMode.offers[0].pieces}
                        idProduct={product.id}
                      />

                      {/* Si il y a plus d'offres */}
                      {product.saleMode.offers.length > 1 && (
                        <div>
                          <p
                            className={classes.plusOffres}
                            onClick={this.clickMoreOffer}
                          >
                            Plus d'offres
                          </p>
                          <Collapse in={this.state.isMoreOffer}>
                            <div>
                              {product.saleMode.offers
                                .filter((offer, i) => i > 0)
                                .map((offer, i) => (
                                  <Prix
                                    key={i}
                                    price={offer.price}
                                    quantity={offer.quantity}
                                    pieces={offer.pieces}
                                    unit={offer.unit}
                                    idProduct={product.id}
                                  />
                                ))}
                            </div>
                          </Collapse>
                        </div>
                      )}
                    </div>
                  ) : (
                    // BulkSale
                    <div>
                      <Prix
                        bulksale
                        price={product.saleMode.price}
                        unit={product.saleMode.unit}
                        idProduct={product.id}
                      />
                    </div>
                  ))}

                {product.producerProfile.hasMail && (
                  <div className={classes.button}>
                    <ModalContactProducteur
                      nameButton={'Contacter le producteur'}
                      titleModal={'Contacter le producteur'}
                      idProducer={product.producerProfile.id}
                    />
                  </div>
                )}

                <hr className={classes.hr} />
                <Titre1 component={'p'}>DU MÊME PRODUCTEUR</Titre1>

                <div>
                  {listProducts &&
                  listProducts.filter(
                    produit => produit.id !== product.id && produit.available
                  ).length > 0 ? (
                    listProducts
                      .filter(
                        produit =>
                          produit.id !== product.id &&
                          produit.available &&
                          produit.saleMode
                      )
                      .map((produit, i) => (
                        <Produit
                          id={produit.id}
                          key={i}
                          photosProduct={produit.photosProduct}
                          name={produit.name}
                          saleMode={produit.saleMode}
                          position={i}
                        />
                      ))
                  ) : (
                    <p className={classes.noProductMessage}>
                      Pas d'autres produits pour ce producteur
                    </p>
                  )}
                </div>
              </Grid>
            ) : (
              <p className={classes.unavailable}>
                Le produit est indisponible ou introuvable
              </p>
            )}
            <PubContainer scriptPubCore={responsiveAd} />
          </div>
        ) : (
          /* ////////////////////////////// Desktop ////////////////////////////// */
          <div className={`${classes.divBorderAF} ${classes.wrapper}`}>
            <Grid
              className={classes.divAF}
              itemScope
              itemType='http://schema.org/Product'
            >
              <TopBarSearch />

              <PubContainer
                scriptPubCore={smBannerAd}
                className={classes.ads}
              />

              {loading ? (
                <Spinner />
              ) : product &&
                product.producerProfile.valid === 'ACCEPTE' &&
                product.available ? (
                <Fragment>
                  <Breadcrumb
                    className={classes.breadcrumb}
                    items={[
                      { name: 'Accueil', to: routes.accueil },
                      {
                        name: product.producerProfile.regionName,
                        to: routes.mapRegion
                          .replace(':category', categoriesOptions[0].value)
                          .replace(
                            ':inseeRegion',
                            product.producerProfile.regionCode
                          )
                          .replace(':page', '1')
                      },
                      {
                        name: product.producerProfile.departmentName,
                        to: routes.mapDepartment
                          .replace(':category', categoriesOptions[0].value)
                          .replace(
                            ':inseeDepartment',
                            product.producerProfile.departmentCode
                          )
                          .replace(':page', '1')
                      },
                      {
                        name: product.producerProfile.companyName,
                        to: routes.ficheProducteur.replace(
                          ':id(\\d+)',
                          product.producerProfile.id
                        )
                      },
                      {
                        name: product.name,
                        active: true
                      }
                    ]}
                  />

                  <Titre1 className={classes.name} itemProp='name'>
                    {product.name}
                  </Titre1>

                  {product.photosProduct.length > 0 &&
                    product.photosProduct.map((photo, i) => (
                      <link key={i} itemProp='image' href={photo.cloudPath} />
                    ))}

                  <hr className={classes.hrTitle} />

                  <Row>
                    <Col sm={5} className={classes.colInfos}>
                      <P>
                        Description: <br />
                        <span itemProp='description'>
                          {interpretHtml(
                            product.description.replace(/\n/g, '<br/>')
                          )}
                        </span>
                      </P>

                      <p className={classes.lienProducteur}>
                        <Link
                          to={routes.ficheProducteur.replace(
                            ':id(\\d+)',
                            product.producerProfile.id
                          )}
                        >
                          <Oeil jaune taille={20} className={classes.oeil} />{' '}
                          Producteur: {product.producerProfile.companyName}
                        </Link>
                      </p>

                      {product.saleMode &&
                        (product.saleMode.offers ? (
                          // PackedSale
                          <div>
                            <Prix
                              price={product.saleMode.offers[0].price}
                              unit={product.saleMode.offers[0].unit}
                              quantity={product.saleMode.offers[0].quantity}
                              pieces={product.saleMode.offers[0].pieces}
                              idProduct={product.id}
                            />

                            {/* Si il y a plus d'offres */}
                            {product.saleMode.offers.length > 1 && (
                              <div>
                                <p
                                  className={classes.plusOffres}
                                  onClick={this.clickMoreOffer}
                                >
                                  Plus d'offres
                                </p>
                                <Collapse in={this.state.isMoreOffer}>
                                  <div>
                                    {product.saleMode.offers
                                      .filter((offer, i) => i > 0)
                                      .map((offer, i) => (
                                        <Prix
                                          key={i}
                                          price={offer.price}
                                          quantity={offer.quantity}
                                          pieces={offer.pieces}
                                          unit={offer.unit}
                                          idProduct={product.id}
                                        />
                                      ))}
                                  </div>
                                </Collapse>
                              </div>
                            )}
                          </div>
                        ) : (
                          // BulkSale
                          <div>
                            <Prix
                              bulksale
                              price={product.saleMode.price}
                              unit={product.saleMode.unit}
                              idProduct={product.id}
                            />
                          </div>
                        ))}

                      {product.producerProfile.hasMail && (
                        <ModalContactProducteur
                          nameButton={'Contacter le producteur'}
                          titleModal={'Contacter le producteur'}
                          idProducer={product.producerProfile.id}
                        />
                      )}
                    </Col>

                    <Col smOffset={1} sm={6}>
                      {product.photosProduct.length > 0 ? (
                        <Carousel photos={product.photosProduct} />
                      ) : (
                        <Carousel />
                      )}

                      {product.producerProfile.categories &&
                        product.producerProfile.categories.length > 0 && (
                          <div>
                            <P className={classes.categorie}>
                              Les catégories de produit de ce producteur :
                            </P>
                            <P className={classes.vert}>
                              {product.producerProfile.categories &&
                                product.producerProfile.categories.map(
                                  (categorie, i) => (
                                    <Fragment key={i}>
                                      <Link
                                        to={routes.siteMap.replace(
                                          ':category',
                                          getUrlValueFromValue(
                                            categorie.reference
                                          )
                                        )}
                                        className={classes.vert}
                                      >
                                        {categorie.reference}
                                      </Link>
                                      {i !==
                                      product.producerProfile.categories
                                        .length -
                                        1
                                        ? ' - '
                                        : ''}
                                    </Fragment>
                                  )
                                )}
                            </P>
                          </div>
                        )}
                    </Col>
                  </Row>

                  <hr className={classes.hr} />

                  <Titre1 component={'p'}>DU MÊME PRODUCTEUR</Titre1>

                  <div className={classes.flexContainer}>
                    {listProducts &&
                    listProducts.filter(
                      produit => produit.id !== product.id && produit.available
                    ).length > 0 ? (
                      listProducts
                        .filter(
                          produit =>
                            produit.id !== product.id &&
                            produit.available &&
                            produit.saleMode
                        )
                        .map((produit, i) => (
                          <div key={i} className={classes.flexItem}>
                            <Produit
                              id={produit.id}
                              photosProduct={produit.photosProduct}
                              name={produit.name}
                              saleMode={produit.saleMode}
                              position={i}
                            />
                          </div>
                        ))
                    ) : (
                      <p className={classes.noProductMessage}>
                        Pas d'autres produits pour ce producteur
                      </p>
                    )}
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <hr className={classes.hrTitle} />
                  <p className={classes.unavailable}>
                    Le produit est indisponible ou introuvable
                  </p>
                </Fragment>
              )}

              <PubContainer
                scriptPubCore={smBannerAd}
                className={classes.ads}
              />
            </Grid>
          </div>
        )}

        {!loading && product && product.available ? (
          <Query
            query={queryForNearCity}
            variables={{ id: product.producerProfile.id }}
          >
            {({ data: { findNearestCityOfAProducer } }) => (
              <Footer cityNear={findNearestCityOfAProducer} />
            )}
          </Query>
        ) : (
          <Footer />
        )}
      </Fragment>
    )
  }
}

export default responsiveComponent(
  withRouter(injectSheet(styles)(FicheProduit))
)
